import React, {Component} from 'react';
import PropTypes from 'prop-types';


import Divider from '@mui/material/Divider';
import FileUploadIcon from '@mui/icons-material/CloudUpload';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import {Button} from '@mui/material';
import {Dialog,DialogTitle,DialogContent,DialogActions} from '@mui/material';
import {ClosableBar} from '../dialogs';
import {QRTagView} from '../view';


const s:any = {
  container: {
    display:'flex',
    justifyContent:'flex-start',
    alignItems: 'center'
  },
  preview: {
    width:200,
    height: 40,
    mt: 1,
    ml: 1,
    mr: 1,
  },
  button: {
    m: 1,
  },
  input: {
    display: 'none',
  },
  hidden: {
    display: 'none'
  },
  visible: {
    display: 'flex'
  }
};

class FTagField extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      loading: false,
      open: false,
      source: undefined,
      value: ' ',
      tag: false,
    };
  }

  getxid = () => {
    const {id='upfile'} = this.props;
    const xid = `_${id}`;
    return xid;
  }
  
  getxname = () => {
    const {name='upfile'} = this.props;
    const xname = `_${name}`;
    return xname;
  }
  // startLoading = () => {
  //   this.setState({loading:true});
  // }

  // stopLoading = () => {
  //   this.setState({loading:false});
  // }
  disableEvent = (event:any) => {
    event.preventDefault();
  };
  onMouseDown = (event:any) => {
    event.preventDefault();
  };

  onOpen = (event:any) => {
    const xid = this.getxid();
    const input = document.getElementById(xid);
    if(input) input.click();
  }

  onClose = (event:any) => {
    this.setState({tag: false});
  }

  onSave = (file:File,coord:any,value:any) => {
    const {others} = this.props;
    const {onExtras} = others;
    if(typeof onExtras === 'function') {
      //const payload = {name:filename,size,data:result,stamp};
      //const filedata = btoa(JSON.stringify(payload));
      const {x:left,y:top} = coord;
      const tag = {left,top,width:100,height:100};
      const records = {tgl:left,tgt:top,tgw:100,tgh:100};
      onExtras('tag',JSON.stringify(tag),records);
    }
    //this.setState({tag:false,value,coord,file});
    this.setState({tag:false,coord});
  }

  setSource = async(event:any,file:any,result:any) => {
    const {onChange} = this.props;
    const {name:filename,size,lastModified:stamp} = file;
    console.log('file: ',file);

    if(typeof onChange === 'function') {
      const payload = {name:filename,size,data:result,stamp};
      const filedata = btoa(JSON.stringify(payload));
      onChange(filedata);
    }

    this.setState({value:filename,source:result});
  }

  onChanged = async(event:any) => {
    event.persist();
    //let that = this;
    //let file:any, fr:any;
    //let files:any = event.target.files || event.dataTransfer.files;
    const files:any = event.target.files || event.dataTransfer.files;
    if (files) {
      const file = files[0];
      const result = new Blob(file);
      await this.setSource(event,file,result);
      // fr = new FileReader();
      // fr.onload = () => { 
      //   that.setSource(event,file,fr.result);
      // };
      // fr.readAsDataURL(file);
    }
  }

  onChange = (event:any) => {
    event.persist();
    //let that = this;
    //let file:any, fr:any;
    //let files:any = event.target.files || event.dataTransfer.files;
    const files:File[] = event.target.files || event.dataTransfer.files;
    if (files) {
      const file = files[0];
      //const result = new Blob(file);
      //await this.setSource(event,file,result);
      
      const {onChange} = this.props;
      const {name:filename,size,lastModified:stamp} = file;
      console.log('file: ',file);

      if(typeof onChange === 'function') {
        //const payload = {name:filename,size,data:result,stamp};
        //const filedata = btoa(JSON.stringify(payload));
        onChange(file);
      }

      //this.setState({value:filename,source:result});
      //Ernie: uncommeny for fileupload mode
      const url = URL.createObjectURL(file);
      this.setState({value:filename,tag: true,url});
    }
  }

  render() {
    const {id,label,name,required,options,previewStyle,divider,classes } = this.props;
    const {preview,accept,InputProps:inprops={},...ooptions} = options||{};
    const {value,tag,url} = this.state;

    //console.log('render.accept',accept,options,required);
    //const {source} = this.state;
    var xid = this.getxid();
    var xname = this.getxname(); 
    var xaccept = accept || "*/*";

    const title = 'NTRMS';

    return (
      <React.Fragment>
        <Dialog open={tag} maxWidth={'lg'}>
          {/* <DialogTitle>
            <ClosableBar onClose={this.onClose}>{title}</ClosableBar>
          </DialogTitle> */}
          <DialogContent>
            <QRTagView url={url} filename={value} onSave={this.onSave} onClose={this.onClose}></QRTagView>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="secondary" onClick={this.onClose}>No, Cancel</Button>
            <Button variant="contained" color="primary" onClick={this.onClose}>Close</Button> 
          </DialogActions>
        </Dialog>
        <TextField
            label={label}
            id={id}
            name={id}
            type={'text'}
            required={required}
            margin='dense'
            fullWidth={true}
            sx={{...s.textField}}            
            value={value}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <label htmlFor={xid}>
                  
                  <IconButton 
                    color={'primary'}
                    onClick={this.onOpen}
                    //onMouseDown={this.onMouseDown}
                  >
                    <FileUploadIcon color={'inherit'}/>
                    <input
                      style={{opacity:0,width:1}}
                      accept={xaccept}
                      id={xid}
                      name={xname}
                      type="file"
                      onChange={this.onChange}
                    />
                  </IconButton>
                  
                  </label>
                </InputAdornment>
              ),
              //readOnly: true,
            }}
            onKeyDown={this.disableEvent}
            //{...ooptions}
          />
        {divider && <Divider />}
      </React.Fragment>
    );
  }
}

FTagField.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FTagField;
